import { initializeApp } from "firebase/app";
import {
  getAuth,
  GoogleAuthProvider,
  OAuthProvider,
  signInWithPopup
} from "firebase/auth";

// Configuration injected from layout
var firebaseConfig = window.FIREBASE_CONFIG || {};

let appFirebase;
let authFirebase;
let googleProvider;
let appleProvider;

if (firebaseConfig && firebaseConfig.apiKey) {
  try {
    appFirebase = initializeApp(firebaseConfig);
    authFirebase = getAuth(appFirebase);
    googleProvider = new GoogleAuthProvider();
    appleProvider = new OAuthProvider("apple.com");
    appleProvider.addScope("email");
    appleProvider.addScope("name");
  } catch (e) {
    console.error("Firebase init failed:", e);
  }
} else {
  console.warn("Firebase config missing apiKey; skipping initialization.");
}

export {
  authFirebase,
  googleProvider,
  appleProvider,
  signInWithPopup
};
